import React from 'react';
import { Link } from 'react-router-dom';
import { FaHandshake, FaClipboardList, FaEnvelope } from 'react-icons/fa';
import './HumanResourcesSection.css';

const hrCards = [
  {
    id: 1,
    icon: <FaHandshake />,
    title: 'Kariyer Fırsatları',
    desc: 'Ekibimize katılın; mentorluk programları, sertifika desteği ve kariyer gelişim fırsatları sizi bekliyor.',
  },
  {
    id: 2,
    icon: <FaClipboardList />,
    title: 'Başvuru Süreci',
    desc: 'Özgeçmiş ve motivasyon mektubunuzu göndermek için aşağıdaki butonu kullanabilirsiniz.',
  }
];

export default function HumanResourcesSection() {
  return (
    <section id="hr-section" className="hr-section">
      <div className="hr-container">
        <h2>İnsan Kaynakları</h2>

        <div className="hr-cards">
          {hrCards.map(card => (
            <div key={card.id} className="hr-card">
              <div className="hr-icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p className="hr-desc">{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="hr-contact">
          <p>Kariyer başvurusu ve özgeçmiş gönderimi için kariyer sayfamızı ziyaret edin:</p>
          <Link
            to="/kariyer"
            className="hr-mail-button"
          >
            <FaEnvelope className="mail-icon" />
            Kariyer Başvurusu
          </Link>
        </div>
      </div>
    </section>
  );
}
